import axios from "axios";

const server = axios.create({
        time: 5000,
        withCredentials: false
    })
    //请求拦截
server.interceptors.request.use((config) => {
       
      
        return config
    }, err => {
        Promise.reject(err);
    })
    //响应拦截

server.interceptors.response.use((res) => {

    if (res.status == 200) {
        return res.data
    }
})
export default server;